import { Action } from '@ngrx/store';
import { AuthActionType } from 'app/core/authentication/state/actions/auth-action-type.enum';

import { LicenseRequestInterface } from '../../models/license-request.model';

export class LicenseCheck implements Action {
  public readonly type: AuthActionType = AuthActionType.LicenseCheck;
  public readonly payload: undefined;

  constructor() { }
}

export class LicenseCheckCompleted implements Action {
  public readonly type: AuthActionType = AuthActionType.LicenseCheckCompleted;

  constructor(public readonly payload: number) { }
}

export class LicenseCheckFailed implements Action {
  public readonly type: AuthActionType = AuthActionType.LicenseCheckFailed;

  constructor(public readonly payload: string) { }
}

export class LicenseUpdate implements Action {
  public readonly type: AuthActionType = AuthActionType.LicenseUpdate;

  constructor(public readonly payload: LicenseRequestInterface) { }
}
